export default "__VITE_ASSET__D86vW1CA__"